import { FormArray, FormControl, FormGroup } from '@angular/forms';

export function removeFormGroupValidators(formGroup: FormGroup) {
  if (formGroup.controls) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      if (control instanceof FormControl) {
        control.setValidators(null);
        control.updateValueAndValidity();
      } else if (control instanceof FormGroup) {
        removeFormGroupValidators(control);
      } else if (control instanceof FormArray) {
        control.controls.forEach((ctrl: FormGroup) => removeFormGroupValidators(ctrl));
      }
    });
  }
}
